import { IAttribute, IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedService } from './linkedservice';
import {
    CredentialTypeOptions,
    IKeyValuePair,
    IViolation,
    shellStringResources,
    azureCloudTypeDef,
    validateAKVLinkedServiceReference,
    Credential
} from 'shell-models-lib';
import { AzureKeyVault } from 'app/model/linkedservice/key-vault';
import { format } from 'app/shared/utils/string.util';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.trino.linkedServiceType,
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.Trino_FormalName),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.Trino_FormalName)
    ]
})
export class TrinoLinkedService extends LinkedService {
    public static readonly MODEL: IModel;
    public static readonly HOST: IAttribute;
    public static readonly CATALOG: IAttribute;
    public static readonly SCHEMA: IAttribute;
    public static readonly CLIENT_ID: IAttribute;
    public static readonly CLIENT_SECRET: IAttribute;
    public static readonly TENANT: IAttribute;
    public static readonly TIMEZONE_ID: IAttribute;

    @Metamodel.attribute({
        association: 'HOST',
        templatable: true
    })
    public host: string;

    @Metamodel.attribute({
        association: 'CATALOG',
        templatable: true
    })
    public catalog: string = 'system';

    @Metamodel.attribute({
        association: 'SCHEMA',
        templatable: true
    })
    public schema: string = 'information_schema';

    public authenticationType: string = CredentialTypeOptions.UserAssignedManagedIdentity;

    @Metamodel.attribute({
        display: stringResources.ModelName_ClientId,
        association: 'CLIENT_ID',
        templatable: true
    })
    public clientId?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_ClientSecret,
        association: 'CLIENT_SECRET',
        templatable: true,
        accepts: ['String'],
        constraint: {
            validator: validateAKVLinkedServiceReference
        }
    })
    public clientSecret?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.ModelName_Tenant,
        association: 'TENANT',
        templatable: true
    })
    public tenant: string;

    // dropdown in service principal, no params
    @Metamodel.attribute({
        display: stringResources.ModelName_AzureCloudType,
    })
    public azureCloudType?: azureCloudTypeDef;

    public sessionProperties?: Array<IKeyValuePair<string, string | null>> = [];

    @Metamodel.attribute({
        display: stringResources.ModelName_Credential,
        reference: true,
        constraint: {
            validator: (
                linkedservice: TrinoLinkedService,
                referencedCredential: Credential
            ): IViolation[] | undefined => {
                if (
                    linkedservice?.authenticationType ===
                    CredentialTypeOptions.UserAssignedManagedIdentity &&
                    !referencedCredential
                ) {
                    return [
                        {
                            message: () =>
                                shellStringResources.Error_InvalidCredentialReferenced,
                        },
                    ];
                }
                return undefined;
            },
        }
    })
    public credential?: Credential;

    constructor(name?: string, description?: string) {
        super(name, description);
    }

    public reset(): void {
        this.clientId = undefined;
        this.clientSecret = undefined;
        this.catalog = undefined;
        this.host = undefined;
        this.schema = undefined;
        this.tenant = undefined;
        this.credential = undefined;
        this.sessionProperties = [];
        this.azureCloudType = undefined;
    }
}
